import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'String' },
    { value: 2, label: 'List' },
    { value: 3, label: 'Integer' },
    { value: 4, label: 'Float' },
    { value: 5, label: 'Boolean' },
    { value: 6, label: 'Value List' },
    { value: 7, label: 'HTML' },
  ],
});
